import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { Panel, VerificationCodeInput } from '@sketch/components';
import { HelpNote } from './HelpNote.js';
import { Title, Description, FormContainer, Note, Paragraph, StyledFakeLinkButton } from '../SignInToLinkAccountView.styles.js';
import { useValidateMfaTotpMutation } from '@sketch/gql-types';

/**
 * Renders the UI that allows the user to enter the verification code
 * This only renders if the user has mfaState === 'ENABLED' which is
 * returned after the user Signs in
 */
const VerificationCode = ({ onCompleted, onError, onVerificationCodeFilled, toggleInterface, mfaToken, verificationError, }) => {
    // Verification Code Validation
    const [validateMfaTotp] = useValidateMfaTotpMutation({
        onCompleted,
        onError,
    });
    const handleVerificationCodeFilled = useCallback((code) => {
        onVerificationCodeFilled();
        // Code from the Authenticator App
        validateMfaTotp({
            variables: {
                token: mfaToken,
                totp: code,
            },
        });
    }, [mfaToken, validateMfaTotp, onVerificationCodeFilled]);
    return (jsxs(Fragment, { children: [jsx(Title, { children: "Enter Verification Code" }), jsxs(Panel.Body, { children: [jsx(Description, { children: "Open your authenticator app and enter the code before it expires \u2014 or wait for a new one." }), jsxs(FormContainer, { children: [jsx(VerificationCodeInput, { onFilled: handleVerificationCodeFilled, error: verificationError }), jsx(Note, { children: jsxs(Paragraph, { children: ["Can\u2019t access your authenticator app?", ' ', jsx(StyledFakeLinkButton, Object.assign({ variant: "tertiary", onClick: toggleInterface, isUnderlined: true }, { children: "Use a recovery code" })), jsx("br", {}), jsx(HelpNote, {})] }) })] })] })] }));
};

export { VerificationCode as default };
